export default "__VITE_ASSET__D3fn5iyf__"